<div class="auth-register-form-container mb-5">
  <div class="flex flex-col md:w-[720px]">
    <button
      class="back-button flex w-fit items-center gap-[6px] p-2 pl-0 text-brand-primary-800"
      type="button"
      (click)="goBack()"
    >
      <aw-icon class="w-5" icon="arrow-left" />
      <span class="font-medium">Back</span>
    </button>

    <div class="mb-10 mt-6 flex w-full flex-col gap-2">
      <p class="text-[18px] font-medium leading-6 text-brand-primary-800">
        Nice to meet you!
      </p>
      <h2 class="text-2xl font-medium leading-9 text-brand-accent-400">
        Let's get to know you
      </h2>
    </div>

    <form class="w-full" [formGroup]="registerForm" (ngSubmit)="submitForm()">
      <div class="mb-5 flex w-full flex-col gap-5 sm:flex-row">
        <aw-form-field class="flex w-full flex-col">
          <aw-input
            name="firstname"
            class="!w-full placeholder:text-po-grey-5"
            formControlName="firstName"
            placeholder="First name"
            autofocus="true"
            [isShowDirhamIcon]="false"
          />

          @if (registerForm.get('firstName')?.errors?.['required']) {
            <aw-form-field-error>
              The first name is required
            </aw-form-field-error>
          }
        </aw-form-field>

        <aw-form-field class="flex w-full flex-col">
          <aw-input
            name="lastname"
            class="!w-full placeholder:text-po-grey-5"
            formControlName="lastName"
            placeholder="Last name"
            [isShowDirhamIcon]="false"
          />

          @if (registerForm.get('lastName')?.errors?.['required']) {
            <aw-form-field-error>
              The last name is required
            </aw-form-field-error>
          }
        </aw-form-field>
      </div>

      <div class="mb-10 flex w-full flex-col gap-5 sm:flex-row">
        <aw-form-field class="flex w-full flex-col">
          <aw-input
            name="email"
            class="!w-full placeholder:text-po-grey-5"
            placeholder="Email address"
            formControlName="email"
            inputmode="email"
            type="email"
            [isShowDirhamIcon]="false"
          />

          @if (registerForm.get('email')?.errors?.['required']) {
            <aw-form-field-error>
              The email address is required
            </aw-form-field-error>
          } @else if (registerForm.get('email')?.errors?.['email']) {
            <aw-form-field-error>
              Please enter a valid email address
            </aw-form-field-error>
          }
        </aw-form-field>

        <aw-form-field class="flex w-full flex-col">
          <aw-phone-input
            formControlName="phoneNumber"
            placeholder="Phone number"
          />

          @if (registerForm.get('phoneNumber')?.errors?.['required']) {
            <aw-form-field-error>
              The phone number is required
            </aw-form-field-error>
          } @else if (registerForm.get('phoneNumber')?.errors?.['valid']) {
            <aw-form-field-error>
              Please enter a valid phone number
            </aw-form-field-error>
          }
        </aw-form-field>
      </div>

      <div class="flex w-full flex-col gap-5 sm:flex-row">
        <div class="flex w-full flex-col">
          <po-button
            class="btn-submit inline-block w-full"
            variant="authSubmit"
            businessUnit="blocks"
            buttonText="Continue"
            type="submit"
            [loading]="isSubmitting() || hasSession()"
            [disabled]="registerForm.invalid"
          >
            <span>Continue</span>
          </po-button>
        </div>

        <div class="w-full flex-col"></div>
      </div>
    </form>

    <div
      class="mt-14 flex flex-row items-center gap-2 text-left text-brand-accent-400"
    >
      <span class="text-left">Already have an account?</span>

      <po-button
        class="mx-2 inline-block w-fit"
        buttonText="Login"
        variant="primary-outline"
        size="small"
        [path]="loginRoute"
        [disabled]="isSubmitting()"
        (clicked)="onLogin()"
        >Login</po-button
      >
    </div>

    <!-- Error Display -->
    @if (error$ | async; as error) {
      <div class="mt-4 text-sm text-po-red-400">
        {{ error.message }}
      </div>
    }
  </div>
</div>
